export enum INTEGRATION_CATEGORY_ENUM {
  CMS = "cms",
  CATALOG = "catalog",
  ANALYTICS = "analytics",
  EMAILING = "emailing",
}

export enum IntegrationErrorCode {
  UNABLE_TO_DETECT_CSV_DELIMITER = "UNABLE_TO_DETECT_CSV_DELIMITER",
  UNKNOWN = "error_occurred",
}
